// extracted by mini-css-extract-plugin
export default {"container":"sponsor_container__qLxaN","title":"sponsor_title__nbUU3","sponsors":"sponsor_sponsors__hTNh2","img":"sponsor_img__qE5OV","largeImg":"sponsor_largeImg__vtJ9Q"};